<template>
  <section class="documents">
    <div v-if="documents">
      <documents-brochure v-if="documents.Brochure" :content="documents.Brochure"></documents-brochure>
      <documents-brochure v-if="documents.ChildBrochure" :content="documents.ChildBrochure"></documents-brochure>      
      <documents-list v-if="documents.ExternalFiles.length" :content="documents.ExternalFiles" title="Files"></documents-list>
      <documents-list v-if="documents.PresentationFiles.length" :content="documents.PresentationFiles"  title="Presentations / Other"></documents-list>
      <documents-list v-if="documents.PressReleaseFiles.length" :content="documents.PressReleaseFiles" title="Press Releases"></documents-list>
      <products-list-category v-if="documents.ProductsInCategory" :content="documents.ProductsInCategory" title="Products in same category"></products-list-category>
    </div>
  </section>
</template>

<script>
import { getDocuments, getProductDocuments } from "./DocumentsActions";

import DocumentsList from "./DocumentsList";
import DocumentsBrochure from "./DocumentsBrochure";
import ProductsListCategory from "../products/ProductsListCategory";

export default {
  components: {
    DocumentsList, DocumentsBrochure, ProductsListCategory
  },
  vuex: {
    getters: {
      documents: state => state.documents,
      isArchive: state => state.isArchive
    },
    actions: { getDocuments, getProductDocuments }
  },
  methods: {
    fetch () {
      if (this.$route.params.id) {
        this.getDocuments(this.$route.params.id, this.isArchive);
      } else {
        this.getProductDocuments(this.$route.params, this.isArchive);
      }
    }
  },
  route: {
    data ({ to: { params: { id } } }) {
      this.fetch();
    }
  },
  watch: {
    "isArchive": function (value) {
      console.log("Archive changed");
      this.fetch();
    }
  }
};
</script>


// WEBPACK FOOTER //
// Documents.vue?27d37900